import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ReviewShare = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M10.6899 17.528L2.94037 14.7775L30.113 6.5304L24.969 22.4946L19.1219 20.5681L13.0096 26.6804L10.6899 17.528Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.7793 6.74503C30.8592 6.49711 30.7948 6.22534 30.6122 6.0396C30.4296 5.85386 30.159 5.78487 29.9097 5.86051L2.73706 14.1076C2.44779 14.1954 2.24756 14.459 2.24055 14.7612C2.23354 15.0634 2.42133 15.336 2.70622 15.4371L10.1033 18.0625L12.331 26.8523C12.3929 27.0964 12.581 27.2884 12.8238 27.3552C13.0666 27.422 13.3265 27.3533 13.5045 27.1753L19.3121 21.3677L24.7499 23.1594C24.927 23.2178 25.1201 23.203 25.2863 23.1185C25.4525 23.034 25.5781 22.8867 25.6353 22.7093L30.7793 6.74503ZM15.3966 20.0332L17.8331 20.8669L14.3034 24.3965L15.3966 20.0332ZM11.5001 17.8752L13.0057 23.8157L14.2237 18.9542C14.2713 18.7642 14.3963 18.6028 14.5684 18.5093C14.5867 18.4994 14.6053 18.4903 14.6242 18.4821L20.3904 13.6769L11.5001 17.8752ZM10.5985 16.7527L5.17949 14.8294L29.0366 7.58858L24.5188 21.6092L19.3447 19.9044L16.3386 18.8758L25.5057 11.2366C25.7764 11.011 25.8372 10.6194 25.6476 10.3223C25.4581 10.0253 25.0773 9.91542 24.7586 10.0659L10.5985 16.7527Z"
          fill="#2B2F38"
        />
      </svg>
    )
  },
)

export default ReviewShare
